import { defineMessages } from 'react-intl';

/**
 * Copy for the citations affordance that replaced the end-of-answer references
 * accordion on the Work surfaces.
 */
export const evidenceCitationsMessages = defineMessages({
  citationsCount: {
    defaultMessage: '{count, plural, one {# citation} other {# citations}}',
    id: 'P7PPSnOEZn',
    description:
      'Label of the button that opens an Evidence answer’s cited sources, showing how many were cited',
  },
  panelTitle: {
    defaultMessage: 'Citations',
    id: '+X/1/Lc2Zw',
    description: 'Title of the panel listing the sources an Evidence answer cited',
  },
  close: {
    defaultMessage: 'Close citations',
    id: '5HH1ZrdYwz',
    description: 'Accessible label of the button that closes the citations panel',
  },
  empty: {
    defaultMessage: 'The cited sources are no longer available for this answer.',
    id: 'PyVwaK4bfX',
    description:
      'Shown in the citations panel when the answer that produced the references is no longer on screen',
  },
});
